module.exports = __webpack_public_path__ + "static/Circular-Valley_Logo-a8aae2147bb46e6f403b1cb7ffefce95.webp";